import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from './local-storage.service';
import { OnboardingV2Service } from './onboarding-v2.service';
import { ONBOARDING_BLACKLISTED_PREVIOUS_ROUTE, ONBOARDING_ROUTE } from '../models/onboarding/onboarding-v2-model';

@Injectable()
export class OnboardingGuard implements CanActivateChild {
    readonly SIGN_UP_ROUTE = 'profile-setup';
    constructor(private localStorage: LocalStorageService, private onboardingService: OnboardingV2Service) {}

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const isContainOnboardingRoute = this.isContainOnboardingRoute(state?.url);
        const stopAccountCreation = isContainOnboardingRoute && this.stopAccountCreation();
        if (stopAccountCreation) {
            this.routeToPreviousPage(this.getPreviousRoute());
        }
        return true;
    }

    stopAccountCreation() {
        const isBrmOnboardedAccount = this.onboardingService.isBrmOnboardedAccount();
        if (isBrmOnboardedAccount) {
            return !this.onboardingService.allowSignupForBrm() && !this.onboardingService.isAccountCreated();
        }
        return !this.onboardingService.allowSignup() && !this.onboardingService.isAccountCreated();
    }

    routeToPreviousPage(url: string) {
        this.onboardingService.routeToPage(url);
    }

    isContainOnboardingRoute(url: string) {
        const containsRoute = ONBOARDING_ROUTE.find((route) => url.includes(route));
        return containsRoute;
    }

    getPreviousRoute() {
        const routeTracker = this.localStorage.getRouteTracker();
        const isSignupRoute = ONBOARDING_BLACKLISTED_PREVIOUS_ROUTE.find((route) => routeTracker?.previousRoute.includes(route));
        return isSignupRoute ? this.onboardingService.login() : routeTracker?.previousRoute;
    }
}
